// extracted by mini-css-extract-plugin
export default {"currencySign":"edmwQJ"};